export default __webpack_public_path__ + "static/media/istockphoto-502584005-612x612.a9592ddf.jpg";